module.exports = __webpack_public_path__ + "img/logo-eib.102be1a6.svg";